import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { migratePreferences } from './preferences/migrations';
import { fetchDataFeeds, fetchUserPreferences, saveUserPreferences } from './thunks';
import { DataFeed, UserPreferencesDto, UserSettingsState, VersionedPreferences } from './types';

export const initialState: UserSettingsState = {
  dataFeeds: [],
  isDataFromTriumph: true,
  rebalanceFromTriumph: true,
  preferences: {},
  loadedPreferencePaths: [],
};

export const userSettingsSlice = createSlice({
  name: '@@store/userSettings',
  initialState,
  reducers: {
    setDataFromTriumph: (state, action: PayloadAction<boolean>) => {
      state.isDataFromTriumph = action.payload;
    },
    setRebalanceFromTriumph: (state, action: PayloadAction<boolean>) => {
      state.rebalanceFromTriumph = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDataFeeds.fulfilled, (state, action: PayloadAction<DataFeed[]>) => {
      state.dataFeeds = action.payload;
    });
    builder.addCase(fetchUserPreferences.fulfilled, (state, action: PayloadAction<UserPreferencesDto>) => {
      state.preferences[action.payload.path] = migratePreferences<VersionedPreferences>(action.payload.path, action.payload.preferences);
      markPathLoaded(state, action.payload.path);
    });
    builder.addCase(fetchUserPreferences.rejected, (state, action) => {
      const path = action.meta.arg?.path;
      if (path) markPathLoaded(state, path);
    });
    builder.addCase(saveUserPreferences.fulfilled, (state, action: PayloadAction<UserPreferencesDto>) => {
      state.preferences[action.payload.path] = migratePreferences<VersionedPreferences>(action.payload.path, action.payload.preferences);
      markPathLoaded(state, action.payload.path);
    });
  },
});

const markPathLoaded = (state: UserSettingsState, path: string) => {
  if (!state.loadedPreferencePaths.includes(path)) {
    state.loadedPreferencePaths.push(path);
  }
};
